<nz-card class="condensed-card">
    <div class="card-header">
        <h2 style="font-weight: bold; font-size: 15px;">
            Crossline: {{jobState.crossline()}}
            @if(jobState.selectedLog(); as data){
                [{{data.name}}]
            }
        </h2>

        <a style="font-size: 20px;" class="omit-from-screenshot" (click)="resetZoom()" nz-tooltip nzTooltipTitle="Reset Zoom">
            <nz-icon nzType="sync" nzTheme="outline" />
        </a>
    </div>

    <div class="slice-viewer">
        @if (sliceResource.isLoading()) {
        <div class="overlay">
            <nz-spin nzSimple nzTip="Fetching Seismic Slice..." nzSize="large"></nz-spin>
        </div>
        }
        @if (sliceResource.error(); as error) {
        <div class="slice-error">
            <nz-alert nzType="error" nzMessage="Error loading slice" [nzDescription]="error.message" nzShowIcon/>
        </div>
        }
        @if (displayData(); as data) {
        <div>
            <app-my-viewer #sliceViewer [sliceImage]="data.sliceImage" [sliceArray]="data.sliceArray" [colorbar]="data.colorbar"
                [limits]="limits()" [horizonDataResource]="horizonsDataResource"
                [sonicDataResource]="sonicLogDataResource" [xIndicator]="jobState.inline()"
                [yIndicator]="jobState.depth()"
                xLabel="Inline"
                yLabel="Depth"
                [viewerHeight]="crosslineViewerHeight()"
                [xCrop]="xCrop()"
                [yCrop]="yCrop()"
            >
            </app-my-viewer>
        </div>
        }
    </div>

</nz-card>